import React from "react" //eslint-disable-line
import { createGlobalStyle } from "styled-components"

const css = {
  breakpoints: {
    narrow: "350px",
    wide: "475px",
    split: "1000px",
  },
  widths: {
    narrow: "250px",
    regular: "350px",
    wide: "450px",
    split: "900px",
  },
  fontSizes: {
    smallDevice: "12px",
    regularDevice: "20px",
  },
}

const GlobalStyles = createGlobalStyle`
  
  :root {
    /* Greyscale */
    --eerie-black: #1c1c1c;
    --charleston-green: #212529;
    --gunmetal: #343a40;
    --toner-gray: #bfc0c0;
    --gray-web: #797d81;
    --pale-chiffron: #f7ece1;
    --baby-powder: #fffffa;

    /* Colors */
    --indigo-dye: #0d3b66;
    --oxford-blue: #141e30;
    --prussian-blue: #243b55;
    --honey-yellow: #f6ae2d;
    --queen-blue: #33658a;
    --spanish-green: #018e42;
    --orange-engineering: #bd0f12;
    --liver: #6b4b3e;

    /* Box shadows */
    --shadow-elavated: 0px 0px 10px 1px rgba(0,0,0,0.1);

    /* Responsiveness */
    --narrow-breakpoint: ${css.breakpoints.narrow};
    --wide-breakpoint: ${css.breakpoints.wide}; 
    --split-breakpoint: ${css.breakpoints.split};

    --narrow-width: ${css.widths.narrow};
    --regular-width: ${css.widths.regular};
    --wide-width: ${css.widths.wide};
    --layout-width-split: ${css.widths.split};

    /* Font size base */
    --small-device-font-base: ${css.fontSizes.smallDevice};
    --regular-font-base: ${css.fontSizes.regularDevice};

    /* Font size globals */
    --font-regular: 1rem;
    --line-regular: 1rem;
    --font-small: 0.75rem;
    --line-small: 1rem;
    --font-sub: 0.6rem;
    --line-sub: 0.8rem;


    /* Shell */
    --footer-height: 1.5rem;
    --body-height: calc(100vh - var(--footer-height));
    --gradient-start: var(--oxford-blue);
    --gradient-end: var(--prussian-blue);

    /* Defaults */
    --full-width: var(--regular-width);
    --layout-width: var(--full-width);
    --black: var(--gunmetal);
    --white: var(--baby-powder);
    --gray-text: var(--gray-web);
    --gray-bg: var(--toner-gray);
    --darkblue: var(--indigo-dye);
  }

  html {
    font-size: var(--regular-font-base);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  body {
    margin: 0;
    background-color: var(--darkblue);
    font-family: 'Noto Sans JP', sans-serif;
    color: var(--black);
  }

  /* Layout breakpoints */
  @media (min-width: ${css.breakpoints.split}) {
    :root {
      --layout-width: var(--layout-width-split);
    }
  }

  @media (min-width: ${css.breakpoints.wide}) {
    :root {
      --full-width: var(--wide-width);
    }
  }

  @media (max-width: ${css.breakpoints.narrow}) {
    :root {
      --full-width: var(--narrow-width);
    }

    html {
      font-size: var(--small-device-font-base);
    }
  }
`

export default GlobalStyles
export { css }